import React, { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';
import { galleryImages } from '../data/mock';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('All');

  const categories = ['All', ...new Set(galleryImages.map((img) => img.category))];

  const filteredImages =
    filter === 'All'
      ? galleryImages
      : galleryImages.filter((img) => img.category === filter);

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="romano-badge mb-4 inline-block">Our Work</span>
          <h2 className="romano-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#622B62] mb-4">
            HVAC Project Gallery
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Browse through our completed projects and see the quality of our work.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`px-6 py-2.5 rounded-full font-medium transition-all ${
                filter === category
                  ? 'bg-[#622B62] text-white shadow-lg'
                  : 'bg-gray-100 text-gray-600 hover:bg-[#622B62]/10 hover:text-[#622B62]'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item relative cursor-pointer group"
              onClick={() => setSelectedImage(image)}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-72 object-cover rounded-2xl"
              />
              <div className="absolute inset-0 bg-[#622B62]/0 group-hover:bg-[#622B62]/60 transition-all duration-300 rounded-2xl flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-center">
                  <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mx-auto mb-3">
                    <ZoomIn size={24} className="text-white" />
                  </div>
                  <span className="text-white font-medium">{image.category}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
              onClick={() => setSelectedImage(null)}
            >
              <X size={28} className="text-white" />
            </button>
            <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
              />
              <div className="mt-4 text-center">
                <p className="text-white text-lg">{selectedImage.alt}</p>
                <span className="inline-block mt-2 px-4 py-1 bg-[#DA9C3A] text-white rounded-full text-sm">
                  {selectedImage.category}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default GallerySection;
